var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.42 15L11.132 8.504C11.315 8.183 11.661 7.976 12.028 8C12.397 8.011 12.73 8.223 12.895 8.553L19.059 20.882L22.132 15.504C22.31 15.192 22.641 15 23 15H31V5C31 2.791 29.209 1 27 1H5C2.791 1 1 2.791 1 5V15H7.42Z",
    fill: "#9966FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.58 17L19.868 23.496C19.69 23.808 19.358 24 19 24H18.972C18.603 23.989 18.27 23.777 18.105 23.447L11.941 11.118L8.868 16.496C8.69 16.808 8.359 17 8 17H1V27C1 29.209 2.791 31 5 31H27C29.209 31 31 29.209 31 27V17H23.58Z",
    fill: "#9966FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitals);
export default __webpack_public_path__ + "static/media/vitals.cfb16fc9379d8b9b79dc03ea159f92f1.svg";
export { ForwardRef as ReactComponent };